import React from 'react';
import styled from 'styled-components';

const StyledPageContainer = styled.div`
  display: flex;
  font-weight: light;
  color: #FFF;
  min-height: 500px;
`;

const PageContainer = (props) => <StyledPageContainer props={props}>{props.children}</StyledPageContainer>

export default PageContainer;


// WEBPACK FOOTER //
// ./src/Containers/PageContainer.js